import { AccordionDetails } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const ButtonWrapper = styled("div")(() => ({
  backgroundColor: colors.white,
  border: `1px solid ${colors.gray200}`,
  padding: "16px 24px",
  marginTop: 32,
  borderRadius: "12px",

  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: 16,
}));

export const ContentWrapper = styled("div")(() => ({
  maxWidth: 1142,
  margin: "0 auto",
  padding: "32px 24px",
}));

export const AccordionDetailsWrapper = styled(AccordionDetails)(() => ({
  flexDirection: "column",
  padding: "32px 24px",
}));

export const StepsWrapper = styled("div")(() => ({
  minHeight: 700,
}));
